export default __webpack_public_path__ + "static/media/bg1.cfa8e5a7.jpg";